import {
  Component,
  forwardRef,
  OnInit,
  Input
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NgForm,
  FormControl,
  ControlValueAccessor,
  Validator
} from '@angular/forms';

import { COUNTRIES } from './countries.data';

export interface CountryInterface {
  n: string;
  i: string;
}

@Component({
  styleUrls: [
    './countries.component.scss'
  ],
  selector: 'jb-input-countries',
  templateUrl: './countries.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => JbInputCountriesComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => JbInputCountriesComponent),
      multi: true
    }
  ]
})
export class JbInputCountriesComponent implements ControlValueAccessor, Validator, OnInit {
  protected type: string = 'countries';

  protected _value: any = '';

  public prefill: string;
  public prefilled: boolean = false;

  public countryPickerActive: boolean = false;
  public selected: CountryInterface = null;

  public countries: CountryInterface[] = COUNTRIES;

  public locale: string;

  public searchCountriesResults: CountryInterface[] = [];

  public searchTerm: string = '';

  public timeout;

  @Input()
  public id: string;

  @Input()
  public name: string;

  @Input()
  public required: any;

  @Input()
  public form: NgForm;

  @Input()
  public submitted: boolean;

  // the method set in registerOnChange to emit changes back to the form
  protected propagateChange = (_: any) => {
    return;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;

    this.propagateChange(val);
  }

  // this is the initial value set to the component
  public writeValue(value: any) {
    if (value) {
      this._value = value;

      for (const country of this.countries) {
        if (country.i === this._value) {
          this.changeCountry(country);

          break;
        }
      }
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  // validates the form, returns null when valid else the validation object
  public validate(c: FormControl) {
    return null;
  }

  // not used, used for touch input
  public registerOnTouched() {
    return;
  }

  public ngOnInit() {
    this.searchCountriesResults = this.countries;

    if (this._value) {
      if (this._value && this.countries.length) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.countries.length; i++) {
          if (this.countries[i].i === this._value) {
            this.selected = this.countries[i];
            break;
          }
        }

        this.prefilled = true;
      }
    }
  }

  public isSubmitted() {
    if (typeof (this.submitted) !== 'undefined') {
      return this.submitted;
    } else if (this.form) {
      return this.form.submitted;
    } else {
      return false;
    }
  }

  public changeCountry(country: CountryInterface) {
    this.selected = country;
    this.value = country.i;

    this.deactivateAll();
  }

  public toggleCountryPicker() {
    this.countryPickerActive = !this.countryPickerActive;
  }

  public deactivateAll() {
    this.countryPickerActive = false;
  }

  public onSearchTermChange(term: string) {
    this.searchTerm = term;

    if (this.countries.length) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      if (!this.searchTerm || !this.searchTerm.length) {
        this.searchCountriesResults = this.countries;
      } else {
        this.timeout = setTimeout(() => {
          this.searchCountriesResults = [];

          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < this.countries.length; i++) {
            if (this.countries[i].n.toLowerCase().indexOf(term.toLowerCase()) > -1) {
              this.searchCountriesResults.push(this.countries[i]);
            }
          }
        }, 200);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/input/countries/countries.component.ts